// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sRyLCva1hLUIQhT6EptI{margin-bottom:4px}.fnIMtUXWjsGDSy60QAuQ{border:1px solid var(--border-neutral-default);border-radius:8px;min-height:80px}.fnIMtUXWjsGDSy60QAuQ:focus-within{border-color:var(--border-brand-default)}.ah8Gsry1AMhS59ym5rNL{height:100px}.AJ322r_IQLk7brt3VIOO{padding-left:0;padding-right:0}.HrGQd30d2KEBofwvEAX9{justify-content:flex-end;gap:12px;padding-top:16px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `sRyLCva1hLUIQhT6EptI`,
	"textToSpeechWrapper": `fnIMtUXWjsGDSy60QAuQ`,
	"textToSpeechText": `ah8Gsry1AMhS59ym5rNL`,
	"textToSpeechInfo": `AJ322r_IQLk7brt3VIOO`,
	"actions": `HrGQd30d2KEBofwvEAX9`
};
export default ___CSS_LOADER_EXPORT___;
